module.exports = __webpack_public_path__ + "img/home_active.877af7b1.svg";